import React from "react";
import App from "./App";
import Panel from "./panel/Panel";

// /panel  -> dashboards (admin y socios)
// cualquier otra ruta -> tu sitio público de siempre
export default function Root() {
  return window.location.pathname.startsWith("/panel") ? <Panel /> : <App />;
}
